import { Link } from "react-router-dom";

const values = [
  {
    icon: "ri-focus-3-line",
    title: "真诚表达",
    desc: "不迎合、不夸张，用真实的内容与观众建立长期信任。",
  },
  {
    icon: "ri-lightbulb-line",
    title: "持续创造",
    desc: "把每一次表达都当作作品来打磨，在稳定输出中不断进化。",
  },
  {
    icon: "ri-heart-3-line",
    title: "保留温度",
    desc: "专业的背后始终保留对人的关怀，让内容有力量也有温度。",
  },
  {
    icon: "ri-compasses-2-line",
    title: "长期主义",
    desc: "不追逐短期的热度，只做经得起时间检验的选择。",
  },
];

const stats = [
  { value: "5+", label: "年品牌沉淀" },
  { value: "60+", label: "内容与作品" },
  { value: "120万+", label: "全网关注" },
  { value: "5城", label: "巡回分享" },
];

export default function BrandIntro() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <div className="relative">
            <div className="h-[360px] w-full overflow-hidden rounded-lg md:h-[480px]">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimal%20editorial%20portrait%20of%20a%20confident%20creative%20professional%20in%20soft%20warm%20studio%20light%2C%20deep%20navy%20background%20with%20subtle%20orange%20accent%2C%20premium%20brand%20photography%20high%20detail&width=1000&height=1200&seq=brand-portrait-01&orientation=portrait"
                alt="张津瑜个人形象照 - 个人品牌官方视觉"
                title="张津瑜 + 个人品牌形象"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 left-5 rounded-lg bg-primary-500 px-5 py-4 text-background-50 md:left-8">
              <p className="font-heading text-lg font-bold leading-none md:text-xl">张津瑜</p>
              <p className="mt-1.5 font-label text-xs uppercase tracking-[0.15em] text-background-200">
                Personal Brand
              </p>
            </div>
          </div>

          <div>
            <span className="inline-flex items-center gap-2 font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
              <span className="h-px w-6 bg-accent-500" />
              About Brand
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              在喧嚣中保持清醒，
              <br className="hidden sm:block" />
              在专业中保留温度
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              张津瑜个人品牌始终相信，真正有生命力的表达来自持续的真诚与稳定的价值观。
              从内容创作到作品实践，再到公益影像，我们试图用一件件具体的作品，回应这个时代对个人品牌的期待。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
              {values.map((value) => (
                <div key={value.title} className="flex gap-3">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                    <i className={`${value.icon} text-xl`} />
                  </span>
                  <div>
                    <h3 className="font-heading text-sm font-bold text-foreground-950">
                      {value.title}
                    </h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">
                      {value.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解品牌故事
              <i className="ri-arrow-right-line text-base" />
            </Link>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-6 rounded-lg bg-primary-900 p-8 md:mt-16 md:grid-cols-4 md:p-10">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center md:text-left">
              <p className="font-heading text-3xl font-bold text-accent-500 md:text-4xl">
                {stat.value}
              </p>
              <p className="mt-2 text-sm text-background-300">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}